import { configureStore } from '@reduxjs/toolkit'
import TonKhoAVPReducer from './reducers/Report/TonKhoAVP'
import KeepStockReducer from './reducers/Report/keepStock'
import CompanySalesReducer from './reducers/Report/companySales'
import CompanySaleOdersReducer from './reducers/Report/companySaleOders'
import CompanySaleOderDetailsReducer from './reducers/Report/companySaleOderDetails'
import CompareCompanySalesReducer from './reducers/Report/compareCompanySales'
import AOPReducer from './reducers/Report/AOP'
import LoadingReducer from './reducers/Loading/loading'
import AuthReducer from './reducers/auth/auth';
import MasterDataReducer  from './reducers/masterData/masterData'
import DocumentMasterDataReducer  from './reducers/document/documentMasterData'
import ServicesStatusReducer  from './reducers/other/servicesStatus'
import thunkMiddleware from 'redux-thunk';
import AccessRolesReducer from './reducers/permistion'
// Store
const store = configureStore({
    reducer: {
        TonKhoAVPReducer,
        CompanySalesReducer,
        CompanySaleOdersReducer,
        CompanySaleOderDetailsReducer,
        LoadingReducer,
        AuthReducer,
        MasterDataReducer,
        DocumentMasterDataReducer,
        KeepStockReducer,
        CompareCompanySalesReducer,
        ServicesStatusReducer,
        AOPReducer,
        AccessRolesReducer
    },
    middleware: [thunkMiddleware]
});

// Export
export default store 